import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/willness/Documents/Projects/N3S/quote-pulse/components/ButtonSupport.tsx");
;
import(/* webpackMode: "eager" */ "/Users/willness/Documents/Projects/N3S/quote-pulse/node_modules/.pnpm/next@14.2.4_@babel+core@7.24.7_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/link.js");
